import { CONSTANTS } from '../modules/constants'

const trialLengthDays = 14 // in days
const offsets = [5, 5, 0, 7, 0, 4, 0]
const multiplier = 837 // = 27 x 31
const offsetKey = 53
const maxDivideError = 0.00001
const codeNumberLength = 7

export const todaysTrialCode = () => {

  // const todayDate = new Date(2022, 4, 25) // set today date to test
  const todayDate = new Date()

  const todayDigits = dateTo7Digits(todayDate)
  // console.log("today digits: ", todayDigits)

  let offsetDigits = []

  for(let i = 0; i < 7; ++i)
    offsetDigits[i] = (todayDigits[i] + offsets[i])%10
  // console.log("offsetDigits: ", offsetDigits)

  let sevenDigits = ""
  for(let i = 0; i < 7; ++i)
    sevenDigits += offsetDigits[i]
  // console.log("sevenDigits: ", sevenDigits)

  const codeValue = (parseInt(sevenDigits) * multiplier) + offsetKey

  let code = `${codeValue}`
  // console.log("code: " + code)
  
  console.log("trial URL string: ", `http://localhost:3000/?trial=${code}`)

  return code
}

const dateTo7Digits = date => {
  // console.log("date: ", date)

  const day = date.getDate()
  const month = date.getMonth() + 1
  const year = date.getFullYear() - 2000

  // console.log("day: " + day)
  // console.log("month: " + month + 1)
  // console.log("year: " + year)

  let digits = []

  digits[0] = day %10

  digits[1] = Math.floor(year / 10)
  digits[2] = year %10

  digits[3] = Math.floor(month / 10)
  digits[4] = month %10

  digits[5] = Math.floor(day / 10)
  digits[6] = day %10

  return digits
}

export const getUrlTrialDaysLeft = urlTrialCode => {
  // console.log("trialCode=" + code)

  if( urlTrialCode === null ) return null
  if( urlTrialCode.length < 2 ) return CONSTANTS.TRIAL_INVALID

  const sevenDigitNumber = (urlTrialCode - offsetKey) / multiplier
  const sevenDigitInteger = Math.round(sevenDigitNumber)
  const divideError = Math.abs(sevenDigitInteger - sevenDigitNumber)
  
  // console.log("sevenDigitInteger=" + sevenDigitInteger)
  // console.log("error=" + divideError)

  if( divideError > maxDivideError)
    return CONSTANTS.TRIAL_INVALID

  const sevenDigitString = `${sevenDigitInteger}`
  let codeChars = sevenDigitString.split("")
  while( codeChars.length < codeNumberLength ) codeChars.unshift("0")
  // console.log("1. chars: ", codeChars)

  let correctedDigits = []
  // subtract offsets
  for(let i = 1; i < 7; ++i)
    correctedDigits[i - 1] = parseInt(codeChars[i]) - offsets[i]
  // console.log("correctedDigits: ", correctedDigits)

  const year = parseInt(`${correctedDigits[0]}${correctedDigits[1]}`) + 2000
  const month = parseInt(`${correctedDigits[2]}${correctedDigits[3]}`) - 1
  const day = parseInt(`${correctedDigits[4]}${correctedDigits[5]}`)
  
  // console.log("day: " + day)
  // console.log("month: " + month)
  // console.log("year: " + year)

  let trialStartDate = new Date(year, month, day, 2) // set to midday to minimise time zone issues
  // console.log("trial start date was: ", trialStartDate)

  const fourteenDays = trialLengthDays * 24 * 60 * 60 * 1000 // in milliseconds
  const now = new Date()

  const timeLeft = trialStartDate.getTime() + fourteenDays - now.getTime()
  let daysLeft = Math.ceil(timeLeft / (1000 * 60 * 60 * 24))
  // console.log("days left = " + daysLeft)

  if( daysLeft > trialLengthDays + 17) // detect spurious early trial codes
    daysLeft = CONSTANTS.TRIAL_INVALID
  
  return daysLeft
}

